import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Modal from 'components/Modal';
import ReportingModal from './ReportingModal';
import ReportTextModal from './ReportTextModal';

import i18n from 'i18n';
import { fitbitGreen } from 'themes';

const Content = styled.div`
  padding-top: 20px;
  text-align: center;
  > a {
    color: ${fitbitGreen};
  }
`;

const ReportedDMCAModal = ({ onClose }) => (
  <Modal
    id="ReportedDMCAModal"
    buttons={[
      {
        text: i18n('component.ReportedModal.Ok')(),
        onClick: onClose
      }
    ]}
    contentAbove={
      <Content>
        {i18n('component.ReportedModal.DMCAText')()}
        &nbsp;
        <a
          href="https://dev.fitbit.com/legal/reporting-apps/"
          target="_blank"
          rel="noopener noreferrer"
        >
          fitbit.com/copyright-infringement
        </a>
      </Content>
    }
    title={i18n('component.ReportedModal.DMCATitle')()}
    onClose={onClose}
  />
);

ReportedDMCAModal.propTypes = {
  onClose: PropTypes.func.isRequired
};

const ReportedModal = ({ onClose }) => (
  <Modal
    id="ReportedModal"
    buttons={[
      {
        text: i18n('component.ReportedModal.Ok')(),
        onClick: onClose
      }
    ]}
    contentAbove={
      <Content>{i18n('component.ReportedModal.OtherText')()}</Content>
    }
    title={i18n('component.ReportedModal.Title')()}
    onClose={onClose}
  />
);

ReportedModal.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default class ReportModal extends Component {
  static propTypes = {
    app: PropTypes.shape().isRequired,
    onClose: PropTypes.func.isRequired
  };

  state = {
    showMode: 'reporting',
    reportReason: ''
  };

  onReport = (selectedType) => {
    switch (selectedType) {
      case 'copyright':
      case 'trademark':
        this.setState({
          showMode: 'reportDMCA',
          reportReason: selectedType
        });
        break;
      default:
        this.setState({
          showMode: 'reportText',
          reportReason: selectedType
        });
    }
  };

  reportEmailLink = (app, reportReason) => {
    const encodedBody = encodeURIComponent(
      `I am reporting this app because: ${reportReason} \r\r${app.name}`
    );

    return `mailto:appgallerysupport@fitbit.com?subject=App Gallery Private App Report&body=${encodedBody}`;
  };

  onReportText = () => {
    this.setState({ showMode: 'reported' });
  };

  render() {
    const { app, onClose } = this.props;
    const { showMode, reportReason } = this.state;
    switch (showMode) {
      case 'reporting':
        return <ReportingModal onClose={onClose} onReport={this.onReport} />;
      case 'reportDMCA':
        return <ReportedDMCAModal onClose={onClose} />;
      case 'reportText':
        return (
          <ReportTextModal
            app={app}
            reportReason={reportReason}
            onClose={onClose}
            onReport={this.onReport}
            getEmailLink={(reason) => this.reportEmailLink(app, reason)}
          />
        );
      case 'reported':
        return <ReportedModal onClose={onClose} />;
      default:
        return null;
    }
  }
}
